__turbopack_context__.v({
  "fleetName": "ZaV82W_fleetName",
  "initialAvatar": "ZaV82W_initialAvatar",
  "userLink": "ZaV82W_userLink",
});
